<template>
    <div class="form-group position-relative" v-if="IsShow">
        <h5 v-if="isShowTitle !== false && labelText" class="CPSForm-label CPSForm-select-label"
            :class="{ 'floatedLabel': (floatedLabel || $attrs['placeholder'] || temp_value) }">{{ $t(labelText) }}<span
                class="text-danger" v-if="validationRules"> *</span></h5>
        <ValidationProvider v-slot="{ errors }" :rules="validationRules" :vid="ControlId ? ControlId : ''">
            <treeselect ref="treeSelect" :options="options" :clearable="clearable === false ? false : true" v-model="temp_value" :value="temp_value" @input="updateValue"
                @select="TreeSelected" :multiple="false" v-bind="$attrs" :placeholder="placeholder ? placeholder : ''" :noResultsText="$t('lbl_EMPBE_NoResultFound')"
                @open="focusInput" @close="checkValue" @blur="checkValue" :searchable="(allowInput !== false) && (searchable === false ? false : true)"
                :appendToBody="appendToBody" :zIndex="zIndex"
                :class="['cps-treeselect', { 'is-invalid': errors.length > 0 }]"/>
            <b-form-invalid-feedback :state="false" v-if="(errors.length)">
                {{ $t(mandatoryText) }}
            </b-form-invalid-feedback>
        </ValidationProvider>
    </div>
</template>
<script>
// https://www.vue-treeselect.cn/
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex'
export default {
    props: ["value", "ControlId", "isshow", "mandatory", "title", "options", "placeholder", "clearable", "isShowTitle", "searchable", "enableValidation", "allowInput", "appendToBody", "zIndex"],
    data() {
        return {
            temp_value: this.value ? this.value : null,
            IsShow: true,
            labelText: this.title,
            mandatoryText: this.mandatory,
            validationRules: this.getValidationRules(),
            floatedLabel: this.checkValue()
        }
    },
    components: {
        // Multiselect,
        Treeselect
    },
    computed: {
        ...mapGetters({
            GetPermissionJsonById: 'responsePermission/getPermissionJsonById',
        }),
        record() {
            return this.GetPermissionJsonById({ ControlId: this.ControlId })
        },
    },
    watch: {
        value() {
            this.temp_value = this.value;
        },
        mandatory() {
            this.mandatoryText = this.mandatory;
            this.validationRules = this.getValidationRules();
        },
        enableValidation() {
            this.validationRules = this.getValidationRules();
        }
    },
        mounted() {
        //read from json
        if (this.record != null) {
            if (this.record.IsShow != null) this.IsShow = this.record.IsShow;
            if (this.record.IsMandatory) this.validationRules = this.getValidationRules();
            if (this.record.IsDisable != null) this.$attrs["disabled"] = this.record.IsDisable;
            if (this.record.Label != null) this.labelText = this.$t(this.record.Label);
            if (this.record.PlaceholderLabel != null) this.$attrs["placeholder"] = this.$t(this.record.PlaceholderLabel);
            if (this.record.MandatoryLabel != null) this.mandatoryText = this.$t(this.record.MandatoryLabel);
            if (this.record.MaxLength != null) this.$attrs["maxlength"] = this.record.MaxLength;
            if (this.record.MinLength != null) this.$attrs["minlength"] = this.record.MinLength;
        }
    },
    methods: {
        getValidationRules() {
            // 如果 enableValidation 为 false，禁用验证
            if (this.enableValidation === false) {
                return null;
            }
            // 如果 mandatory 为 null，禁用验证
            if (this.mandatory == null) {
                return null;
            }
            // 否则启用必填验证
            return { required: true };
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        updateValue(e) {
            this.temp_value = !this.temp_value ? null :this.temp_value;
            this.$emit("input", this.temp_value);
        },
        TreeSelected(e) {
            this.$emit("fromChird_TreeSelected", e);//fromChird_TreeSelected 为子控件的选择事件  
        },
        getValidationStateClass({ dirty, validated, valid = null }) {
            if (this.getValidationState({ dirty, validated, valid })) {
                return "form-control is-valid";
            }
            else {
                return "form-control";
            }
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            };
            this.options.push(tag);
            this.temp_value.push(tag);
        },
        focusInput() {
            this.floatedLabel = true;
        },
        checkValue() {
            const value = this.temp_value;
            if (value === null || value === undefined || value === '') {
                this.floatedLabel = false;
                return;
            }
            if (typeof value === 'number') {
                this.floatedLabel = true;
                return;
            }
            if (typeof value === 'string' && value.length > 0) {
                this.floatedLabel = true;
                return;
            }
            this.floatedLabel = true;
        },

    }
}
</script>
<style lang="scss">
.vue-treeselect {
    cursor: pointer;

    &.is-invalid {
        > .vue-treeselect__control {
            border-color: #dc3545 !important;
        }
    }

    &:not(.vue-treeselect--disabled):hover {
        .vue-treeselect__control-arrow-container {
            .vue-treeselect__control-arrow {
                color: #616161;
            }
        }
    }

    // Vertical Align of input text
    .vue-treeselect__control {
        .vue-treeselect__value-container {
            .vue-treeselect__single-value {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
            }
        }
    }
}

.multiselect__tags {
    min-height: 2.25rem !important;
    display: block;
    padding: 5px 40px 0px 8px !important;
    border-radius: 5px;
    border: 1px solid #ced4da !important;
    background: #fff;
    font-size: 14px;
}

.multiselect__placeholder {
    margin-bottom: 5px;
}

.vue-treeselect__placeholder {
    color: #898989;
    font-size: 14px;
    font-family: sans-serif;
    font-weight: 100;
}

.vue-treeselect__control {
    border: 1px solid #ced4da !important;
}
</style>